/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderVkontakteComVkIdOptions(value) {
    if (!('ClientId' in value) || value['ClientId'] === undefined)
        return false;
    if (!('ShowOkLogin' in value) || value['ShowOkLogin'] === undefined)
        return false;
    if (!('ShowMailRuLogin' in value) || value['ShowMailRuLogin'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ClientId': json['ClientId'],
        'Scope': json['Scope'] == null ? undefined : json['Scope'],
        'ShowOkLogin': json['ShowOkLogin'],
        'ShowMailRuLogin': json['ShowMailRuLogin'],
    };
}
export function FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ClientId': value['ClientId'],
        'Scope': value['Scope'],
        'ShowOkLogin': value['ShowOkLogin'],
        'ShowMailRuLogin': value['ShowMailRuLogin'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions.js.map